import { jsx as i } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as n } from "../../../external/preact/hooks/dist/hooks.module.js";
import { TypographyVariant as s } from "../Typography/types.js";
/* empty css                   */
import { getCapitalHeaderSubtitleByLegalEntity as m } from "./helpers.js";
import { useConfigContext as l } from "../../../core/ConfigContext/context.js";
import { Header as p } from "../Header/Header.js";
const d = (a) => {
  var e;
  const t = (e = l().extraConfig) == null ? void 0 : e.legalEntity, o = n(() => {
    const r = m(t);
    return r ? { subtitleKey: r } : {};
  }, [t]);
  return /* @__PURE__ */ i(p, { ...a, ...o, subtitleConfig: { variant: s.CAPTION, classNames: "adyen-pe-capital-header__subtitle" } });
};
export {
  d as CapitalHeader
};
